<template>
  <div>
    <dx-data-grid ref="grid" :dataSource="dataSource" :allow-column-reordering="true" @exporting="gridExporting"
      :column-min-width="120" column-resizing-mode="widget" :allow-column-resizing="true" :column-auto-width="true"
      width="100%" :height="height" @init-new-row="(x) => $emit('init-new-row', x)">
      <dx-header-filter :visible="showFilterRow">
        <dx-search :enabled="true" mode="contains"></dx-search>
      </dx-header-filter>
      <dx-grouping :context-menu-enabled="true"></dx-grouping>
      <dx-group-panel :visible="showGroupPanel"></dx-group-panel>
      <dx-paging :enabled="paging" :page-size="20" :page-index="0"></dx-paging>
      <dx-pager :visible="paging" :show-navigation-buttons="false" :show-info="true"
        :show-page-size-selector="false"></dx-pager>
      <dx-search-panel :visible="searchEnabled" width="240"></dx-search-panel>
      <dx-scrolling :scroll-by-content="true" mode="virtual"></dx-scrolling>
      <dx-filter-panel :visible="showFilterRow"></dx-filter-panel>
      <dx-filter-row :visible="showFilterRow"></dx-filter-row>
      <dx-column-chooser :enabled="true"></dx-column-chooser>
      <dx-selection :mode="selectionMode"></dx-selection>
      <dx-state-storing :enabled="stateStoringEnabled" :storage-key="storageKey"></dx-state-storing>
      <dx-editing :allow-adding="bolehBaru" :allow-updating="bolehEdit" :allow-deleting="bolehHapus"
        new-row-position="viewportBottom" :use-icons="true"></dx-editing>
      <dx-export :enabled="bolehExport" :formats="gridExportFormats"></dx-export>
      <dx-toolbar>
        <dx-item name="groupPanel"></dx-item>
        <dx-item name="searchPanel"></dx-item>
        <dx-item v-if="bolehExport" name="exportButton"></dx-item>
        <dx-item name="columnChooserButton"></dx-item>
        <dx-item v-if="bolehSetting" location="after" widget="dxButton"
          :options="{ icon: 'fa fa-gear', onClick: x => $emit('setting') }">
        </dx-item>
        <dx-item name="refresh" v-if="showRefresh" location="after" widget="dxButton"
          :options="{ icon: 'refresh', onClick: onRefresh }">
        </dx-item>
        <dx-item v-if="bolehBaru" location="after" widget="dxButton"
          :options="{ icon: 'add', onClick: onBaru }"></dx-item>
        <dx-item v-for="(item, index) in headerToolbar" :key="index" :widget="item.widget" :location="item.location"
          :options="item.options"></dx-item>
      </dx-toolbar>
      <dx-column type="buttons">
        <dx-button name="ubah" icon="fas fa-edit" @click="onEdit" :visible="editVisible"></dx-button>
        <dx-button name="hapus" icon="fas fa-trash" @click="onHapus" :visible="hapusVisible"></dx-button>
        <dx-button name="print" icon="fas fa-print" @click="onCetak" :visible="cetakVisible"></dx-button>
        <dx-button name="save"></dx-button>
        <dx-button name="cancel"></dx-button>
      </dx-column>

      <dx-column v-for="(item, index) in columns" :key="index" :data-field="item.dataField" :caption="item.caption"
        :data-type="item.dataType" :format="getColumnFormat(item)" :visible="item.visible"
        :editor-options="item.editorOptions" :lookup="item.lookup" :width="item.width"
        :allow-editing="item.allowEditing" :set-cell-value="item.setCellValue"
        :calculate-cell-value="item.calculateCellValue"
        :calculate-display-value="item.calculateDisplayValue"
        :cell-template="item.cellTemplate"></dx-column>
      <dx-summary>
        <dx-total-item v-for="(item, index) in totalItems" :key="index" :summary-type="item.summaryType"
          :column="item.column" display-format="{0}" :value-format="item.valueFormat"></dx-total-item>
      </dx-summary>
    </dx-data-grid>
  </div>
</template>

<script>
import GridHelper from "@/helper/grid-helper";
import {
  DxDataGrid,
  DxSelection,
  DxSearch,
  DxToolbar,
  DxItem,
  DxButton,
  DxColumn,
  DxSummary,
  DxTotalItem,
  DxColumnChooser,
  DxStateStoring,
  DxFilterRow,
  DxExport,
  DxEditing,
  DxScrolling,
  DxFilterPanel,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxHeaderFilter,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";

export default {
  components: {
    DxDataGrid,
    DxSelection,
    DxSearch,
    DxToolbar,
    DxItem,
    DxButton,
    DxColumn,
    DxSummary,
    DxTotalItem,
    DxColumnChooser,
    DxStateStoring,
    DxFilterRow,
    DxExport,
    DxEditing,
    DxScrolling,
    DxFilterPanel,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxHeaderFilter,
    DxPaging,
    DxPager,
  },
  methods: {
    editVisible(e) {
      return !e.row.isEditing && this.bolehEdit;
    },
    hapusVisible(e) {
      return !e.row.isEditing && this.bolehHapus;
    },
    cetakVisible(e) {
      return !e.row.isEditing && this.bolehCetak;
    },
    onCetak(e) {
      this.$emit("cetak", e);
    },
    gridExporting: GridHelper.onExporting,
    getColumnFormat(col) {
      switch (col.dataType) {
        case "date":
          return "dd-MM-yyyy HH:mm:ss";
        case "number":
          return "#,##0.##;(#,##0.##)";
        default:
          return "";
      }
    },
  },
  props: {
    headerToolbar: {
      type: Array,
      default: () => [],
    },
    selectionMode: {
      type: String,
      default: "none",
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },
    showFilterRow: {
      type: Boolean,
      default: true,
    },
    showGroupPanel: {
      type: Boolean,
      default: true,
    },
    searchEnabled: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default: 580,
    },
    paging: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Array,
      default: () => [],
    },
    storageKey: {
      type: String,
      default: "grid",
    },
    gridExportFormats: {
      type: Array,
      default: () => ["xlsx", "csv", "pdf"],
    },
    onBaru: {
      type: Function,
      default: () => { },
    },
    onEdit: {
      type: Function,
      default: () => { },
    },
    onHapus: {
      type: Function,
      default: () => { },
    },
    onRefresh: {
      type: Function,
      default: () => { },
    },
    bolehBaru: {
      type: Boolean,
      default: true,
    },
    bolehSetting: {
      type: Boolean,
      default: false
    },
    bolehEdit: {
      type: Boolean,
      default: true,
    },
    bolehHapus: {
      type: Boolean,
      default: true,
    },
    bolehExport: {
      type: Boolean,
      default: true,
    },
    bolehCetak: {
      type: Boolean,
      default: false,
    },
    daftar: {
      type: Object || Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["cetak", "setting", "init-new-row"],
  computed: {
    stateStoringEnabled() {
      return this.storageKey !== "";
    },
    instance() {
      return this.$refs.grid.instance;
    },
    dataSource: {
      get() {
        return this.daftar;
      },
      set(value) {
        this.$emit("update:daftar", value);
      },
    },
  },
};
</script>
